var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFieldAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 136,
    height: 95,
    viewBox: "0 0 136 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_9",
    x: 0,
    y: 0,
    width: 136,
    height: 95,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_60",
    "data-name": "Grupo 60",
    transform: "translate(-396 -503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_51",
    "data-name": "Grupo 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_37",
    "data-name": "Grupo 37",
    transform: "translate(-368 407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20",
    "data-name": "Grupo 20"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 764, 96)",
    filter: "url(#Trazado_9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_9-2",
    "data-name": "Trazado 9",
    transform: "translate(9 9)",
    fill: "#e897ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 111 76.5 L 7 76.5 C 3.415892362594604 76.5 0.5 73.5841064453125 0.5 70 L 0.5 7 C 0.5 3.415892362594604 3.415892362594604 0.5 7 0.5 L 111 0.5 C 114.5841064453125 0.5 117.5 3.415892362594604 117.5 7 L 117.5 70 C 117.5 73.5841064453125 114.5841064453125 76.5 111 76.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7 1 C 3.691581726074219 1 1 3.691581726074219 1 7 L 1 70 C 1 73.30841827392578 3.691581726074219 76 7 76 L 111 76 C 114.3084182739258 76 117 73.30841827392578 117 70 L 117 7 C 117 3.691581726074219 114.3084182739258 1 111 1 L 7 1 M 7 0 L 111 0 C 114.8659973144531 0 118 3.134002685546875 118 7 L 118 70 C 118 73.86599731445312 114.8659973144531 77 111 77 L 7 77 C 3.134002685546875 77 0 73.86599731445312 0 70 L 0 7 C 0 3.134002685546875 3.134002685546875 0 7 0 Z",
    stroke: "none",
    fill: "#314164"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    d: "M0,0V75.75",
    transform: "translate(832.5 105.25)",
    fill: "none",
    stroke: "#314164",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13",
    "data-name": "Grupo 13",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_35",
    "data-name": "L\\xEDnea 35",
    y2: 58,
    transform: "translate(805 115)",
    fill: "none",
    stroke: "#314164",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_36",
    "data-name": "L\\xEDnea 36",
    y2: 57,
    transform: "translate(860 115.5)",
    fill: "none",
    stroke: "#314164",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12",
    "data-name": "Grupo 12",
    transform: "translate(72 -301.25)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_37",
    "data-name": "L\\xEDnea 37",
    x2: 118,
    transform: "translate(701 473.25)",
    fill: "none",
    stroke: "#314164",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_38",
    "data-name": "L\\xEDnea 38",
    x2: 118,
    transform: "translate(701 415.25)",
    fill: "none",
    stroke: "#314164",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_39",
    "data-name": "L\\xEDnea 39",
    x2: 55,
    transform: "translate(805 143.5)",
    fill: "none",
    stroke: "#314164",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldAvailable);
export default __webpack_public_path__ + "static/media/field-available.3f5cc2cd94b3f16890d184805b61ea89.svg";
export { ForwardRef as ReactComponent };